import {ChangeDetectorRef, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AbstractVisbosComponent} from '../../../../../core/visbos-core/components/abstract-visbos.component';
import {SessionActions} from '../../../../../shared/actions';
import {ActivatedRoute} from '@angular/router';
import {FormBuilder} from '@angular/forms';
import {RfidService} from '../../../../../identity/services/rfid.service';
import {ApolloQueryObservable} from 'apollo-angular';
import {ResolveItemsByEPCsQuery, RetrieveEPCsByReaderQuery, RetrievePackingEPCsByReaderQuery} from '../../../../../shared/graphql/graphql.types';
import {MarriageService} from '../../../services/marriage.service';

@Component({
  selector: 'vb-scan-packing-page',
  templateUrl: './scan-packing-page.component.html',
  styleUrls: ['./scan-packing-page.component.css']
})
export class ScanPackingPageComponent extends AbstractVisbosComponent implements OnInit {

  private readerQuery$: ApolloQueryObservable<RetrievePackingEPCsByReaderQuery>;
  private resolverQuery$: ApolloQueryObservable<ResolveItemsByEPCsQuery>;

  lastItem;
  lastEpc = '';

  errorText;

  @Output()
  itemIdentified: EventEmitter<any> = new EventEmitter();

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private route: ActivatedRoute, private fb: FormBuilder,
              private rfidService: RfidService, private marriageService: MarriageService) {
    super(sessionActions, cd);

  }

  ngOnInit() {
    super.ngOnInit();
  }

  readRFID() {
    this.sessionActions.initAsyncAction();
    if (!this.readerQuery$) {
      this.readerQuery$ = this.rfidService.retrievePackingEpcsFromReader({readerCuid: this.rfidService.getReaderForMarriage()}, 'network-only');
      this.addComponentData(this.readerQuery$);
      this.addSubscription(this.readerQuery$.subscribe(res => {
        if (!res.loading) {
          this.sessionActions.finishAsyncAction();
        }
        this.resolveEPC(res.data.packingEpcsFromReader);
      }, err => {
        this.sessionActions.finishAsyncAction();
        this.sessionActions.throwError(err, 'Fehler beim Abrufen der RFID-Daten!', 'RFID-Lesevorgang');
      }));
    } else {
      this.readerQuery$.refetch().then(
        res => {
          if (!res.loading) {
            this.sessionActions.finishAsyncAction();
          }
          this.resolveEPC(res.data.packingEpcsFromReader);
        }, err => {
          this.sessionActions.finishAsyncAction();
          this.sessionActions.throwError(err, 'Fehler beim Abrufen der RFID-Daten!', 'RFID-Lesevorgang');
        }
      );
    }
  }

  resolveEPC(epcs: string[]) {
    if (!epcs || !epcs.length) {
      this.errorText = "Es wurde kein RFID-Tag im Lesefeld erkannt!";
      return;
    }

    if (epcs.length > 1) {
      this.errorText = "Es wurden mehrere RFID-Tags im Lesefeld erkannt, bitte stellen Sie sicher, dass nur exakt ein Tag gelesen wird!";
      return;
    }

    this.lastEpc = epcs[0];
    this.resolverQuery$ = this.rfidService.resolveEPCs({epcs: [epcs[0]], includeChildren: false}, 'network-only');
    this.addComponentData(this.resolverQuery$);
    this.addSubscription(this.resolverQuery$.subscribe(res => {
      this.processResolveResult(res.data);
    }));
  }

  processResolveResult(data) {

    if (!data.itemsByEPCs || !data.itemsByEPCs.length) {
      this.errorText = "Es wurde keine Verpackungseinheit für den Code '" + this.lastEpc + "' im System gefunden!";
      return;
    }

    this.errorText = null;
    this.lastItem = data.itemsByEPCs[0];
    this.itemIdentified.emit(this.lastItem);
    this.marriageService.setCurrentParentAsset(this.lastItem);
    this.marriageService.lastEpcs = [...this.marriageService.lastEpcs, this.lastEpc];
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/asset-management/components/asset-marriage-wizard/scan-packing-page/scan-packing-page.component.ts